import { Box, Button, Stack, Typography } from '@mui/material';
import React, { useLayoutEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useGetOwnerProfileQuery } from '../../../app/Slices/SevenDayApiSlice';
import OwnerProfileSummary from '../../components/Profile/OwnerProfile/OwnerProfileSummary';
import OwnerProfileListings from '../../components/Profile/OwnerProfile/OwnerProfileListings';
import OwnerProfileReviews from '../../components/Profile/OwnerProfile/OwnerProfileReviews';
import OwnerProfileDiscounts from '../../components/Profile/OwnerProfile/OwnerProfileDiscounts';
import UserRole from '../../../shared/AuthRoles';
import { OwnerRole } from '../../enums/users';
import OwnerProfileStats from '../../components/Profile/OwnerProfile/OwnerProfileStats';
import { ArrowBack } from '@mui/icons-material';

const OwnerProfilePage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const loggedInUser = UserRole();

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { data: owner, isError } = useGetOwnerProfileQuery(Number(id), {
        skip: !id,
    });

    const canEdit =
        (loggedInUser.role === OwnerRole.Admin ||
            loggedInUser.role === OwnerRole.Company) &&
        loggedInUser.company === owner?.id;

    if (isError) navigate('/error');

    return (
        <Box sx={{ maxWidth: 'md', mx: 'auto' }}>
            <Typography variant='h1'>
                {canEdit ? 'Your' : 'Host'} Profile
            </Typography>
            <Stack spacing={8} sx={{ mt: 4 }}>
                {owner && (
                    <OwnerProfileSummary owner={owner} canEdit={canEdit} />
                )}
                {owner && owner.discounts.length > 0 && (
                    <OwnerProfileDiscounts owner={owner} />
                )}
                {owner && <OwnerProfileListings owner={owner} />}
                {owner && <OwnerProfileReviews owner={owner} />}
                {owner && <OwnerProfileStats owner={owner} />}
            </Stack>

            <Button
                startIcon={<ArrowBack />}
                onClick={() => navigate(-1)}
                sx={{ my: 4 }}
            >
                Back
            </Button>
        </Box>
    );
};

export default OwnerProfilePage;
